import { PublicClientApplication } from '@azure/msal-browser';
import { getMsalConfig } from '@/shared/config/msalConfig';

let instance: PublicClientApplication | null = null;

/**
 * PublicClientApplication 싱글톤.
 * Lazy initialization — MSAL 미설정 환경에서 불필요한 인스턴스 생성 방지.
 */
export function getMsalInstance(): PublicClientApplication {
  if (!instance) {
    instance = new PublicClientApplication(getMsalConfig());
  }
  return instance;
}
